import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ChartViewIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 21.8 22"
    >
      <g transform="translate(1 1)">
        <path
          d="M1169.872,11.391h5.528a7.913,7.913,0,0,0-7.934-7.891v7.891h2.406"
          transform="translate(-1155.6 -3.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1168.737,21.242a7.663,7.663,0,0,0,2.271-5.45h-7.752"
          transform="translate(-1155.6 -3.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1163.256,15.792V8.084a7.708,7.708,0,1,0,5.481,13.158"
          transform="translate(-1155.6 -3.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
